import { render, staticRenderFns } from "./CourseDetailPage.vue?vue&type=template&id=b7a05a80&scoped=true&"
import script from "./CourseDetailPage.vue?vue&type=script&lang=js&"
export * from "./CourseDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailPage.vue?vue&type=style&index=0&id=b7a05a80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a05a80",
  null
  
)

export default component.exports